import { EmblaOptionsType } from 'embla-carousel';
import React from 'react';
import {  CarouselBeta, CarouselSlideBeta } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import { ENV } from '../../environment';


import styles from './SocialMedia.module.scss';

const SocialMedia = () => {

  const { t } = useTranslation();
  const options: EmblaOptionsType = {

        breakpoints: {
    '(min-width: 650px)': {
        align: 'center',
        slidesToScroll: 1,
      },

      '(min-width: 700px)': {
        align: 'start',
        slidesToScroll: 2,
      },             
    '(min-width: 960px)': {
        align: 'start',
        slidesToScroll: 3,
      },
    '(min-width: 1399px)': {
        align: 'start',
        slidesToScroll: 4,
      },
      '(min-width: 1499px)': {
        align: 'start',
        slidesToScroll: 4,
      },
    },

    slidesToScroll: 1,
  };

  const cardData = [
    {
      image: `${ENV.IMAGE_CDN}/social-media/Dog1.jpg`, 
    },
    {
      image: `${ENV.IMAGE_CDN}/social-media/Cat1.jpg`, 
    },
    {
       image: `${ENV.IMAGE_CDN}/social-media/Dog2.jpg`, 
    },

    {
     image: `${ENV.IMAGE_CDN}/social-media/Cat2.jpg`, 
  
    },
    {      
      image: `${ENV.IMAGE_CDN}/social-media/Dog3.jpg`, 
   
    },
    {
       image: `${ENV.IMAGE_CDN}/social-media/Cat3.jpg`, 
 
    },
   
  ];

  return (
    <>
      <section>
        <div className={styles.topTitle}>{t('ob.socialmedia.header')}</div>
        <div className={styles.sectionBackground}>
         
          <CarouselBeta
            id="social-media-carousel"
            nextButtonAriaLabel="next"
            previousButtonAriaLabel="previous"
            className={styles.carouselOffers}
            emblaOptions={options}
            gap={'12px'}>
            {cardData.map((card, index) => (
              <CarouselSlideBeta key={`the-key-${index}`} data-testid={`the-key-id-${index}`}>
                {/* <a href={card.url}> */}
                    <div className={styles.stepWrapper} >
                        <img src={card.image}  className={styles.imageMedia} />
                    </div>
                {/* </a> */}
              </CarouselSlideBeta>
            ))}
          </CarouselBeta>
        </div>
      </section>
    </>
  );
};

export default SocialMedia;
